var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var JobRequest_1;
import { JSON, JsonDiscriminatorProperty, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import '@symon-ai/wisepipe-usages-domain'; // force import for JsonSchemaV2
import { EngineMode } from '@symon-ai/wisepipe-base-pipe';
import { PyJobRequestType } from './pyJobRequestType';
import { jobRequestSchemaValidation } from '../validations.generated';
const MAX_TIMEOUT = 4 * 60 * 60 * 1000; // 4 hour
export const jobRequestSchema = {
    $id: 'urn:wisepipe-python-job-domain:JobRequest',
    type: 'object',
    properties: {
        engineMode: { type: 'string', enum: Object.values(EngineMode) },
        requester: { type: 'string', minLength: 1 },
        orgID: { type: 'string', format: 'uuid' },
        usage: { $ref: 'urn:wisepipe-usages-domain:UsageInput' },
        pyJobRequestType: { type: 'string', enum: Object.values(PyJobRequestType) },
        pipeIDrunID: { type: 'string' }
    },
    required: ['engineMode', 'requester', 'orgID']
};
let JobRequest = JobRequest_1 = class JobRequest {
    constructor(engineMode, requester, orgID, usage, pyJobRequestType, pipeIDrunID) {
        this.engineMode = engineMode;
        this.requester = requester;
        this.orgID = orgID;
        if (usage)
            this.usage = usage;
        if (pyJobRequestType)
            this.pyJobRequestType = pyJobRequestType;
        if (pipeIDrunID)
            this.pipeIDrunID = pipeIDrunID;
        JSON.validate(this, JobRequest_1);
    }
    static formatRequester(...parts) {
        return parts.join('.');
    }
};
JobRequest.MAX_TIMEOUT = MAX_TIMEOUT;
JobRequest = JobRequest_1 = __decorate([
    JsonSchemaV2(jobRequestSchema, jobRequestSchemaValidation),
    JsonDiscriminatorProperty('engineMode')
], JobRequest);
export { JobRequest };
//# sourceMappingURL=jobRequest.js.map